import React, { Component } from "react";

import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon"
import Modal from '@mui/material/Modal';

import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDButton from "components/MDButton";
import Avatar from '@mui/material/Avatar';

import MenuItem from '@mui/material/MenuItem';


import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import MyDataTable from "components/DataTable";
import PageTitle from "components/PageTitle";
import tableData from "DBTables/commessa.json"
import { UPLOAD_PATH, STATUS_WORKER } from "constant.js";
import defaultUser from 'assets/images/default-user.png';

import * as ajax from "helpers/ajax";
import CalendarIcon from 'components/CalendarIcon'
import { ROLES } from "constant"

import { filterEmptyWorkers } from "../../helpers/functions";

const monthNames = ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno",
    "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"];

const weekNames=["Domenica","Lunedi","Martedi","Mercoledi","Giovedi","Venerdi","Sabato"]



export default class Gestione extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedMezzo: this.props.id,
            selectedDay:this.props.selectedDate?new Date(this.props.selectedDate):new Date(),
            selectedWorkerDay: null,
            selectedNoteDay: null,

            listOperai: this.props.operai,
            listWorkingDays: [],
            listWorkingDaysAllMezzo: [],
            listNote:[],

            nameFilter:"",
        }

        this.refCalendar = null;
    }

    componentDidMount = () => {
        this.loadWorkingDay();
        document.addEventListener("keydown", this._handleDocumentClick, false);
    }

    _handleDocumentClick = (e) => {
        if (this.state.selectedWorkerDay != null && this.saveButton && e.key=="Enter" ) {
            this.saveButton.click()
        }
    }


    renderListaOperai = () => {
        let arr = [];
        let list = this.state.listOperai

        list = list.filter(list => (list.nome.toLowerCase().includes(this.state.nameFilter.toLowerCase()) || list.cognome.toLowerCase().includes(this.state.nameFilter.toLowerCase()) || list.mansione.toLowerCase().includes(this.state.nameFilter.toLowerCase()) ));

        let listOrdered = [];

        list.map((el) => {

            if (this.state.listWorkingDaysAllMezzo.some(e => e.operaio.id === el.id)) {
                el["exist"] = true
                listOrdered.push(el)
            } else {
                el["exist"] = false
                listOrdered.unshift(el)
            }
        })


        listOrdered.map((el, index) => {
            arr.push(
                <Grid container alignItems={"center"} my={1} p={1} sx={{ borderBottom: "1px solid #00000080" }} key={"list-operai-" + index} sx={{ backgroundColor: (el.exist)?"#cccccc80":"transparent", borderRadius:2 }}>
                    <Grid item sm={6} >
                        <Grid container alignItems={"center"}>
                            <Grid item mr={2}>
                                <Avatar src={UPLOAD_PATH + "/file/operai/" + el.id + ".png"} size={"xs"} alt={el.nome.toUpperCase()} sx={{ width: 24, height: 24 }} />
                            </Grid>
                            <Grid item>
                                <MDTypography variant={"caption"}>{el.nome}{" "}{el.cognome}</MDTypography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item sm={5}>
                        <MDTypography variant={"caption"}>{el.mansione}</MDTypography>
                    </Grid>
                    {[ROLES.segreteria, ROLES.risorse_umane].includes(global.user.ruolo) ? null :
                        <Grid item sm={1}>
                            <MDButton variant="gradient" color="success" iconOnly size={"small"} onClick={() => this.addWorker(el.id)}>
                                <Icon>add</Icon>
                            </MDButton>
                        </Grid>
                    }
                </Grid>
            )
        })

        return arr
    }

    convertDate = (date) => {
        var yyyy = date.getFullYear().toString();
        var mm = (date.getMonth() + 1).toString();
        var dd = date.getDate().toString();

        var mmChars = mm.split('');
        var ddChars = dd.split('');

        return yyyy + '-' + (mmChars[1] ? mm : "0" + mmChars[0]) + '-' + (ddChars[1] ? dd : "0" + ddChars[0]);
    }


    changeMonth = (n) => {
        let date = this.state.selectedDay
        date.setMonth(date.getMonth() + n);
        this.setState({ selectedDay: date }, this.loadWorkingDay)
        this.setintelCalendarDate(date)
    }

    changeDay = (n) => {
        let date = this.state.selectedDay
        date.setDate(date.getDate() + n);
        this.setState({ selectedDay: date }, this.loadWorkingDay)
        this.setintelCalendarDate(date)
    }

    setintelCalendarDate = (date) => {
        let day = date.getDate();
        let month = date.getMonth()+1;
        let year = date.getFullYear();
        if (day < 10) {
            day = '0' + day;
        }

        if (month < 10) {
            month = `0${month}`;
        }

        let output = year + "-" + month + "-" + day;
        this.refCalendar.setDate(output)

    }

    setDate = (val) => {
        let date = new Date(val)
        this.setState({ selectedDay: date }, this.loadWorkingDay)
    }

    loadWorkingDay = () => {
        this.props.setDateCallback(this.state.selectedDay)
        ajax.ajaxGetStrapi("operai-mezzis?populate=*&filters[data][$eq]=" + this.convertDate(this.state.selectedDay) + "&filters[mezzo][id][$eq]=" + this.state.selectedMezzo, this.loadListWorkingDay)
        ajax.ajaxGetStrapi("operai-mezzis?populate=*&filters[data][$eq]=" + this.convertDate(this.state.selectedDay), this.loadListWorkingDayAllMezzo)
        ajax.ajaxGetStrapi("mezzi-notes?populate=*&filters[data][$eq]=" + this.convertDate(this.state.selectedDay) + "&filters[mezzo][id][$eq]=" + this.state.selectedMezzo, this.loadListNote)
    }

    loadListWorkingDay = (response) => {
        this.setState({ listWorkingDays: filterEmptyWorkers(response.data) })
    }

    loadListWorkingDayAllMezzo = (response) => {
        this.setState({ listWorkingDaysAllMezzo: filterEmptyWorkers(response.data) })
    }

    loadListNote = (response) => {
        this.setState({ listNote: response.data })
    }

    addWorker = (id) => {

        if (this.state.listWorkingDaysAllMezzo.some(e => e.operaio.id === id)) {
            if (!window.confirm("Questo operaio è gia associatio ad un altro mezzo per il giorno selezionato, sicuro di volerlo aggiungere?")) {
                return
            } 
        }

        let data = {
            data: {
                operaio: id,
                mezzo: this.state.selectedMezzo,
                data:this.state.selectedDay
            }
        }

        ajax.ajaxPostStrapi("operai-mezzis", data, this.workerAdded)
        
    }

    workerAdded = (response) => {
        this.loadWorkingDay()
        ajax.ajaxGetStrapi("operai-mezzis?populate[commessa][fields][0]=nome&populate=operaio&filters[id][$eq]=" + response.data.id)
    }


    renderCalendar = () => {
        return (
            <>
                <Grid container justifyContent={"space-between"} alignItems={"center"} >
                    <Grid item>
                        <MDButton variant="text" color="dark" onClick={() => this.changeMonth(-1)}><Icon>keyboard_double_arrow_left</Icon></MDButton>
                    </Grid>
                    <Grid item>
                        <MDTypography variant={"h3"} mr={2}>
                            <CalendarIcon onChange={(val) => this.setDate(val)} style={{ verticalAlign: "unset" }} ref={(ref) => this.refCalendar = ref}/>
                            {monthNames[this.state.selectedDay.getMonth()]}{" "}{this.state.selectedDay.getFullYear()}
                        </MDTypography>
                    </Grid>
                    <Grid item>
                        <MDButton variant="text" color="dark" onClick={() => this.changeMonth(1)}><Icon>keyboard_double_arrow_right</Icon></MDButton>
                    </Grid>
                </Grid>

                <Grid container justifyContent={"space-between"} alignItems={"center"} px={5}  >
                    <Grid item>
                        <MDButton variant="text" color="dark" onClick={() => this.changeDay(-1)}><Icon>keyboard_arrow_left</Icon></MDButton>
                    </Grid>
                    <Grid item>
                        <MDTypography variant={"h5"} mr={2}>{weekNames[this.state.selectedDay.getDay()]}{", "}{this.state.selectedDay.getDate()}</MDTypography>
                    </Grid>
                    <Grid item>
                        <MDButton variant="text" color="dark" onClick={() => this.changeDay(1)}><Icon>keyboard_arrow_right</Icon></MDButton>
                    </Grid>
                </Grid>

                <Grid container>
                    {this.renderNote()}
                    {this.renderWorkerInCalendar()}
                </Grid>
            </>
        );
    }

    renderWorkerInCalendar = () => {
        let arr = [];
        this.state.listWorkingDays.map((el, index) => {
            if (!el.operaio) {return}
            arr.push(
                <Grid item key={"worker-day-" + index} mb={1} mr={1}>
                    <MDButton color="info" size="small" onClick={() => {
                        if (![ROLES.segreteria].includes(global.user.ruolo)) {
                            this.setState({ selectedWorkerDay: el })
                        }
                    }}>
                        {el.operaio.nome} {el.operaio.cognome}
                    </MDButton>
                </Grid>
            )
        })
        return arr;
    }


    deleteWorkerDay = () => {
        ajax.ajaxDeleteStrapi("operai-mezzis/" + this.state.selectedWorkerDay.id, this.deleteSaveCallback)
    }


    deleteSaveCallback = (response) => {
        this.setState({ selectedWorkerDay: null }, this.loadWorkingDay)
    }



    addNota = () => {
        let data = {
            data: {
                mezzo: this.state.selectedMezzo,
                data: this.state.selectedDay
            }
        }

        ajax.ajaxPostStrapi("mezzi-notes", data, this.notaAdded)
    }

    notaAdded = () => {
        this.loadWorkingDay()
    }


    renderNote = () => {
        let arr = [];

        this.state.listNote.map((el, index) => {
            arr.push(
                <Grid item key={"note-day-" + index} mb={1} mr={1}>
                    <MDButton color="warning" size="small" onClick={() => {
                        if (![ROLES.segreteria].includes(global.user.ruolo)) {
                            this.setState({ selectedNoteDay: el })
                        }
                    }}>
                       {el.note? el.note:"NOTE"}
                    </MDButton>
                </Grid>
            )
        })
        return arr;
    }

    saveNotaDay = () => {
        let data = {
            data: {
                note: this.state.selectedNoteDay.note,
            }
        }
        ajax.ajaxPutStrapi("mezzi-notes/" + this.state.selectedNoteDay.id, data, this.deleteNotaCallback)
    }

    deleteNotaDay = () => {
        ajax.ajaxDeleteStrapi("mezzi-notes/" + this.state.selectedNoteDay.id, this.deleteNotaCallback)
    }

    deleteNotaCallback = (response) => {
        this.setState({ selectedNoteDay: null }, this.loadWorkingDay)
    }


    render() {
        return (
            <>

                <Grid container mt={5}>
                    <Grid item sm={12} md={6} pr={2}>
                        <MDBox sx={{ backgroundColor: "white!important" }} p={3} borderRadius="lg" shadow="lg" >
                            {[ROLES.segreteria].includes(global.user.ruolo) ? null :
                                <MDButton fullWidth color="warning" sx={{ marginBottom: 2 }} onClick={() => this.addNota()}>
                                    <Icon style={{ marginRight: 10 }}>add</Icon>
                                    Aggiungi nota
                                </MDButton>
                            }
                            <MDInput type="search" fullWidth label="Cerca" onChange={(e) => { this.setState({ nameFilter: e.target.value }) }} />
                            {this.renderListaOperai()}
                        </MDBox>
                    </Grid>
                    <Grid item sm={12} md={6} pl={2}>
                        <MDBox sx={{ backgroundColor: "white!important" }} p={3} borderRadius="lg" shadow="lg" >
                            {this.renderCalendar()}
                        </MDBox>
                    </Grid>
                </Grid>


                {this.state.selectedWorkerDay != null ?
                    <Modal
                        open={this.state.selectedWorkerDay != null}
                        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                        onClose={() => this.setState({ selectedWorkerDay: null })}
                        style={{
                            margin: "auto", display: "flex", alignItems: "center", justifyContent: "center"
                        }}
                    >
                        <MDBox
                            bgColor={"white"}
                            borderRadius="lg"
                            p={2}
                            minWidth={400}
                        >

                            <Grid container={true}>
                                Sicuro di voler eliminare l'assegnazione?
                            </Grid>

                            <Grid container>
                                <Grid item xs pr={1}>
                                    <MDButton fullWidth color="error" onClick={() => this.deleteWorkerDay()}>
                                        <Icon style={{ marginRight: 10 }}>delete</Icon>
                                        elimina
                                </MDButton>
                                </Grid>
                            </Grid>
                        </MDBox>
                    </Modal>
                    : null
                }

                {this.state.selectedNoteDay != null ?
                    <Modal
                        open={this.state.selectedNoteDay != null}
                        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                        onClose={() => this.setState({ selectedNoteDay: null })}
                        style={{
                            margin: "auto", display: "flex", alignItems: "center", justifyContent: "center"
                        }}
                    >
                        <MDBox
                            bgColor={"white"}
                            borderRadius="lg"
                            p={2}
                            minWidth={400}
                        >
                            <MDBox
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                                mx={2}
                                mt={-3}
                                p={2}
                                mb={1}
                                textAlign="center"
                            >
                                <MDTypography variant="h2" fontWeight="medium" color="white" mt={1}>
                                    Modifica Nota
                            </MDTypography>
                            </MDBox>

                            <Grid container={true} >
                                <Grid item sm={12} mb={2}>
                                    <MDInput fullWidth readOnly multiline rows={5}
                                        placeholder={"Scrivi le note dell'assegnazione veicolo"}
                                        value={this.state.selectedNoteDay.note}
                                        onChange={(e) => {
                                            this.setState(prevState => ({
                                                selectedNoteDay: {
                                                    ...prevState.selectedNoteDay,
                                                    note: e.target.value
                                                }
                                            }))
                                        }}

                                    />
                                </Grid>
                            </Grid>

                            <Grid container>
                                <Grid item xs pr={1}>
                                    <MDButton fullWidth color="error" onClick={() => this.deleteNotaDay()}>
                                        <Icon style={{ marginRight: 10 }}>delete</Icon>
                                        elimina
                                </MDButton>
                                </Grid>
                                <Grid item xs pr={1}>
                                    <MDButton fullWidth color="success" ref={(ref) => this.saveButton = ref} onClick={() => this.saveNotaDay()}>
                                        <Icon style={{ marginRight: 10 }}>add</Icon>
                                        Salva
                                </MDButton>
                                </Grid>
                            </Grid>
                        </MDBox>
                    </Modal>
                    : null
                }



            </>
        )
    }
}




Gestione.defaultProps = {

}
